"use client";

// Toast primitive — row #137 α full alert sweep extraction.
//
// Presentational component for transient or persistent error/info/warning/success
// messaging. Replaces browser-native window.alert() in admin surfaces (/settings
// + /owner). Pattern source: ChatContent.js:384-391 pathToast (chat-internal;
// not migrated this ship — out of scope per Catch 21).
//
// Auto-dismiss default 4s; persistent: true opts out (manual dismiss via click).
// Keyed by parent ToastProvider with stacked vertical offset for chained toasts.

import { useEffect } from "react";

export default function Toast({ message, variant = "info", persistent = false, onDismiss, offset = 0 }) {
  useEffect(() => {
    if (persistent) return;
    const timer = setTimeout(onDismiss, 4000);
    return () => clearTimeout(timer);
  }, [persistent, onDismiss]);

  const variantStyles = {
    error: { background: "var(--color-error, #C04A2A)", color: "var(--color-bg)" },
    warning: { background: "var(--color-warning, #C4A35A)", color: "var(--color-bg)" },
    info: { background: "var(--color-accent)", color: "var(--color-text-inverse)" },
    success: { background: "var(--color-text)", color: "var(--color-bg)" },
  };
  const styles = variantStyles[variant] || variantStyles.info;

  return (
    <div
      role={variant === "error" ? "alert" : "status"}
      aria-live={variant === "error" ? "assertive" : "polite"}
      onClick={onDismiss}
      style={{
        position: "fixed",
        bottom: `calc(var(--space-5) + ${offset}px)`,
        left: "50%",
        transform: "translateX(-50%)",
        padding: "var(--space-2) var(--space-4)",
        borderRadius: "var(--radius-md)",
        fontSize: "var(--font-size-xs)",
        fontFamily: "var(--font-primary)",
        zIndex: 10001,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        cursor: "pointer",
        maxWidth: "min(90vw, 480px)",
        textAlign: "center",
        lineHeight: "var(--line-height-relaxed)",
        ...styles,
      }}
    >
      {message}
    </div>
  );
}
